function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { sans as zoram, lineHeightLoose, fontSize16, fontWeightNormal, fontWeightBold } from "../../../../eden-style-constants";
import shared from "./shared";
const Container3 = styled.div.withConfig({
  componentId: "sc-1szn76m-0"
})(["font-family:", ";font-weight:", ";line-height:", ";font-size:", ";", ";& b,& strong{font-weight:", ";}"], zoram, fontWeightNormal, lineHeightLoose, fontSize16, shared, fontWeightBold);

const Text3 = ({
  children,
  as = "div",
  ...props
}) => /*#__PURE__*/React.createElement(Container3, _extends({
  as: as
}, props), children);

Text3.propTypes = {
  /** Content */
  children: PropTypes.node.isRequired,

  /** What html tag or custom react element to render the text as */
  as: PropTypes.node
};
export default Text3;